import { IntegrityMonitorAddCustomRulePanelWebComponent } from './component/IntegrityMonitorAddCustomRulePanelWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_ADD_CUSTOM_RULE } from '../../../../webcomponents.constants';

export { IntegrityMonitorAddCustomRulePanelWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_ADD_CUSTOM_RULE,
  IntegrityMonitorAddCustomRulePanelWebComponent
);
